/** The owner-approved Compass Approach mark; paint follows the active report theme. */
export function CompassMark({ symbolOnly = false }: { symbolOnly?: boolean } = {}) {
  return (
    <svg
      className="compass-mark"
      viewBox={symbolOnly ? "8 0 48 72" : "0 0 246 72"}
      role={symbolOnly ? undefined : "img"}
      aria-hidden={symbolOnly || undefined}
      aria-label={symbolOnly ? undefined : "Compass Approach"}
    >
      <g fill="none" stroke="var(--ir-accent)" strokeWidth="1.25" strokeLinejoin="round">
        <path
          d="M32 3 34 9 40 11 34 13 32 19 30 13 24 11 30 9Z"
          fill="var(--ir-accent)"
          stroke="none"
        />
        <path d="M32 25 37 43 32 39 27 43Z" fill="var(--ir-accent)" fillOpacity=".2" />
        <path d="M52 43 34 48 38 43 34 38Z" />
        <path d="M32 63 27 45 32 49 37 45Z" />
        <path d="M12 43 30 38 26 43 30 48Z" />
        <circle cx="32" cy="43" r="2" fill="var(--ir-accent)" stroke="none" />
      </g>
      {!symbolOnly && (
        <g fill="var(--ir-text)" fontFamily="Inter, Arial, sans-serif" textAnchor="middle">
          <text x="157" y="34" fontSize="21" fontWeight="600" letterSpacing="2.7">
            COMPASS
          </text>
          <text x="157" y="54" fontSize="12" fontWeight="500" letterSpacing="4.4">
            APPROACH
          </text>
        </g>
      )}
    </svg>
  );
}
